module.exports = __webpack_public_path__ + "img/products-viewed-empty.c615ae0.webp";